/* istanbul ignore file */
export { default } from './bookingSummaryPricingTable'
